import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded'
import TrackProgressList from '../components/TrackProgressList'
import { useAdvancedOverviewState } from '../api/AdvancedOverviewProvider'
import { useTracks } from '../api/selectors'
import { useTrackCatalog } from '../api/useTrackCatalog'
import { AdvancedCareTeamMember } from '../api/types'
import { CARE_PLAN_TAB_ID, useTabNavigation } from '../dashboard/tabNavigationContext'
import { trackTitle } from '../dashboard/tracks/trackTransitions'
import { useLeadDirectory } from '../dashboard/tracks/useLeadDirectory'
import { advancedColors } from '../theme'

const NO_CARE_TEAM: AdvancedCareTeamMember[] = []

// Read-only: tracks are started, ended and reassigned from the Master Care Plan (ADR-094).
const TrackProgressPanel = () => {
  const tracks = useTracks()
  const catalog = useTrackCatalog()
  const overview = useAdvancedOverviewState()
  const leads = useLeadDirectory(overview.status === 'ready' ? overview.overview.careTeam : NO_CARE_TEAM)
  const { openTab, hasTab } = useTabNavigation()

  return (
    <Box>
      <TrackProgressList
        tracks={tracks}
        titleFor={(trackKey) => trackTitle(catalog, trackKey)}
        leadFor={(track) => leads.leadLabel(track.providerUid)}
      />
      {hasTab(CARE_PLAN_TAB_ID) ? (
        <Button
          size="small"
          endIcon={<ArrowForwardRoundedIcon />}
          onClick={() => openTab(CARE_PLAN_TAB_ID)}
          sx={{ mt: 1, color: advancedColors.green }}
        >
          Manage tracks in the Master Care Plan
        </Button>
      ) : (
        <Typography variant="caption" sx={{ display: 'block', mt: 1, color: advancedColors.inkFaint }}>
          Tracks are managed in the Master Care Plan.
        </Typography>
      )}
    </Box>
  )
}

export default TrackProgressPanel
